const AI_ENDPOINT = 'https://vitradatacollection.vitraaspire.com/special/process/askAI.aspx';

export const fetchAIReflection = async (
  situation: string,
  options: string[],
  finalComment: string
): Promise<string> => {
  const prompt = `Situation: ${situation}
Options:
${options.map((o, i) => `- ${o}`).join('\n')}
Final comment: ${finalComment || '(none)'}`;

  try {
    const response = await fetch(`${AI_ENDPOINT}?decide=${encodeURIComponent(prompt)}`);
    if (!response.ok) {
      throw new Error('AI request failed');
    }
    let reflection = await response.text();

    // Trim markdown code block syntax if present
    reflection = reflection.trim();
    if (reflection.startsWith('```') && reflection.endsWith('```')) {
      reflection = reflection.slice(3, -3).trim();
    }

    return reflection;
  } catch (error) {
    console.error('AI reflection error:', error);
    throw error;
  }
};
